import React, { useMemo } from 'react'
import { HelpIcon } from './helpers'
import { ExtendedOption } from './types'
import { FormControl } from 'app/modules/shared/components/form/form-control'
import Checkbox from 'app/components/checkbox'
import { ScanProfileOptions } from 'app/modules/user/features/profile/types'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'

type ExtendedOptionsBodyProps = {
  allDisabled: boolean
  data?: ScanProfileOptions
  onOptionChange?: CallableFunction
  fields: ExtendedOption[]
}
const ExtendedOptionsBody = ({ allDisabled, data, onOptionChange, fields }: ExtendedOptionsBodyProps) => {
  const { _t } = useTypedTranslation()

  // Split options into two columns
  const groupedFields = useMemo(() => {
    const result: [ExtendedOption[], ExtendedOption[]] = [[], []]
    // Split into columns
    for (let i = 0; i < fields.length; i++) {
      const target = i < fields.length / 2 ? 0 : 1
      result[target].push(fields[i])
    }

    return result
  }, [fields])

  return (
    <div className="custom-popover-body row">
      {groupedFields.map((group, idx) => (
        <div className="col" key={idx}>
          {group.map((field) => {
            const value = data?.[field.name]
            const checked = !!value && !field.disabled

            return (
              <FormControl
                key={field.name}
                parentClass="d-flex mb-4 align-items-start"
                control={
                  <>
                    <Checkbox
                      id={field.name}
                      label={field.label}
                      className="d-inline-flex align-items-center"
                      checked={checked}
                      onChange={onOptionChange?.(field.name)}
                      disabled={field.disabled || allDisabled}
                    />
                    <HelpIcon tooltipId={field.name + 'Tooltip'} note={field.note} disabled={field.disabled} />
                  </>
                }
              />
            )
          })}
        </div>
      ))}

      {!groupedFields[0].length ? <i className="text-muted">{_t('no-options')}</i> : null}
    </div>
  )
}

export default ExtendedOptionsBody
